import { searchEventsRoutePaths } from '#/modules/search/events/routing/searchEvents.route-paths';
import { searchInternshipsRoutePaths } from '#/modules/search/internships/routing/searchInternships.route-paths';
import { searchJobsRoutePaths } from '#/modules/search/jobs/routing/searchJobs.route-paths';
import { searchOrgsRoutePaths } from '#/modules/search/orgs/routing/searchOrgs.route-paths';
import type { SearchType } from '#/modules/search/types/SearchType';
import { searchVolopsRoutePaths } from '#/modules/search/volops/routing/seachVolops.route-paths';

export function getListingTypeFromPathname(pathname: string): SearchType {
  if (searchJobsRoutePaths.includes(pathname)) {
    return 'JOB';
  }

  if (searchInternshipsRoutePaths.includes(pathname)) {
    return 'INTERNSHIP';
  }

  if (searchVolopsRoutePaths.includes(pathname)) {
    return 'VOLOP';
  }

  if (searchEventsRoutePaths.includes(pathname)) {
    return 'EVENT';
  }

  if (searchOrgsRoutePaths.includes(pathname)) {
    return 'ORG';
  }

  return 'JOB';
}
